document.addEventListener("DOMContentLoaded", function () {
  const dialog = document.querySelector(".inventory-popup");
  const showButton = document.getElementById("dialogInventoryTrigger");
  const closeButton = document.getElementById("closedDialog");

  if (!dialog || !showButton || !closeButton) return;

  const variants = dialog.querySelector(
    ".select-size.boa-shoes-variant-list.block-swatch-list",
  );
  const showOnlyStockedCheckbox = dialog.querySelector(
    "#show-only-stocked-branches",
  );
  const productId = dialog.dataset.productId;
  let cachedInventoryData = null;
  let currentVariantId = null;

  function getProductForm() {
    const sectionForm = dialog
      .closest(".shopify-section")
      ?.querySelector('form[is="product-form"]');
    if (sectionForm) return sectionForm;

    return document.querySelector(
      `form[is="product-form"][id*="-${productId}-"]`,
    );
  }

  function getSelectedVariantId() {
    const variantInput = getProductForm()?.querySelector('input[name="id"]');
    return variantInput?.value ? String(variantInput.value) : null;
  }

  function isInventoryProductForm(form) {
    const inventoryForm = getProductForm();
    return Boolean(inventoryForm && form === inventoryForm);
  }

  function syncPopupVariantSelection(variantId) {
    if (!variantId) return;

    dialog
      .querySelector(".selected-variant")
      ?.classList.remove("selected-variant");

    dialog
      .querySelector(`.block-swatch__item[value="${variantId}"]`)
      ?.classList.add("selected-variant");
  }

  function updateInventoryForVariant(variantId) {
    if (!cachedInventoryData || variantId == null) return;

    currentVariantId = String(variantId);
    syncPopupVariantSelection(currentVariantId);
    displayInventory(cachedInventoryData, currentVariantId, dialog);
    updateStockedBranchesVisibility(dialog);
  }

  showButton.addEventListener("click", async () => {
    cachedInventoryData = await getInventory(productId);

    updateInventoryForVariant(getSelectedVariantId());

    if (variants && !variants.dataset.inventoryListenerAttached) {
      variants.dataset.inventoryListenerAttached = "true";
      variants.addEventListener("click", (event) => {
        if (!(event.target instanceof Element)) return;

        const variantOption = event.target.closest(".block-swatch__item");
        if (!variantOption || !variants.contains(variantOption)) return;

        updateInventoryForVariant(variantOption.getAttribute("value"));
      });
    }

    dialog.showModal();
    document.body.style.overflow = "hidden";
  });

  document.addEventListener("variant:change", (event) => {
    if (!dialog.open || !cachedInventoryData) return;
    if (!isInventoryProductForm(event.target)) return;

    updateInventoryForVariant(event.detail?.variant?.id);
  });

  showOnlyStockedCheckbox?.addEventListener("change", () => {
    showOnlyStockedCheckbox.toggleAttribute(
      "checked",
      showOnlyStockedCheckbox.checked,
    );
    updateStockedBranchesVisibility(dialog);
  });

  closeButton.addEventListener("click", () => {
    dialog.close();
    document.body.style.overflow = "auto";
  });

  dialog.addEventListener("click", (e) => {
    if (e.target === dialog) {
      dialog.close();
      document.body.style.overflow = "auto";
    }
  });
});

async function getInventory(id) {
  try {
    const variants = Array.from(
      document.querySelectorAll(
        ".inventory-popup .select-size .block-swatch__item",
      ),
    ).map((el) => el.getAttribute("value"));

    const inventoryByVariant = sessionStorage.getItem(
      `inventoryByVariant-${id}`,
    );
    if (inventoryByVariant) {
      variants.forEach((variant) => {
        if (!JSON.parse(inventoryByVariant)[variant]) {
          document
            .querySelector(
              `.inventory-popup .block-swatch__item[value="${variant}"]`,
            )
            ?.classList.add("is-disabled");
        }
      });
      return JSON.parse(inventoryByVariant);
    }

    const response = await fetch(`/apps/api/store/inventory/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Get product location inventory fail");
    }

    const jsonResponse = await response.json();
    if (!jsonResponse.success) {
      throw new Error("Get product location inventory fail");
    }
    sessionStorage.setItem(
      `inventoryByVariant-${id}`,
      JSON.stringify(jsonResponse.data),
    );

    variants.forEach((variant) => {
      if (!jsonResponse.data[variant]) {
        document
          .querySelector(
            `.inventory-popup .block-swatch__item[value="${variant}"]`,
          )
          ?.classList.add("is-disabled");
      }
    });
    return jsonResponse.data;
  } catch (error) {
    console.error("error: ", error);
  }
}

function displayInventory(data, variantId, root = document) {
  if (!data || !variantId) return;

  root.querySelectorAll(".branch-inventory").forEach((branch) => {
    branch
      .querySelectorAll(
        ".notAvailable:not(.hidden), .available:not(.hidden), .lastItems:not(.hidden)",
      )
      .forEach((inventoryDisplay) => {
        inventoryDisplay?.classList.add("hidden");
      });

    const branchItem = branch.closest(".boa-branch-item");

    if (!branch.dataset.id) {
      branchItem?.setAttribute("data-inventory-status", "not-available");
      return;
    }
    const inventory = data[variantId]?.inventoryByLocation[branch.dataset.id];
    if (!inventory) {
      branchItem?.setAttribute("data-inventory-status", "not-available");
      return branch.querySelector(".notAvailable").classList.remove("hidden");
    }
    if (inventory > 5) {
      branchItem?.setAttribute("data-inventory-status", "available");
      return branch.querySelector(".available").classList.remove("hidden");
    }
    if (inventory <= 5 && inventory > 0) {
      branchItem?.setAttribute("data-inventory-status", "last-items");
      return branch.querySelector(".lastItems").classList.remove("hidden");
    }
  });
}

function updateStockedBranchesVisibility(root = document) {
  const showOnlyStocked = root.querySelector("#show-only-stocked-branches");
  const shouldHideUnstocked = Boolean(showOnlyStocked?.checked);

  root.querySelectorAll(".boa-branch-item").forEach((branchItem) => {
    const isNotAvailable =
      branchItem.getAttribute("data-inventory-status") === "not-available";
    const shouldHide = shouldHideUnstocked && isNotAvailable;
    branchItem.classList.toggle("hidden", shouldHide);

    const separator = branchItem.nextElementSibling;
    if (separator?.tagName === "HR") {
      separator.classList.toggle("hidden", shouldHide);
    }
  });
}
